package dk.rheasoft.csaware.api.statistics

import kotlinx.serialization.Serializable

@Serializable
data class NamedCount(val name: String, val subName: String, val count: Int)


